// Frozen store listing URLs for the Folio native apps.
export const APP_STORE_URL = "https://apps.apple.com/app/folio-ai/id6670756063";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=ai.quantus17.savannah";
